import { render, staticRenderFns } from "./productCategory.vue?vue&type=template&id=1c055aee&scoped=true"
import script from "./productCategory.vue?vue&type=script&lang=js"
export * from "./productCategory.vue?vue&type=script&lang=js"
import style0 from "./productCategory.vue?vue&type=style&index=0&id=1c055aee&prod&lang=css"
import style1 from "./productCategory.vue?vue&type=style&index=1&id=1c055aee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c055aee",
  null
  
)

export default component.exports